"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
require("core-js/modules/es.array.reduce");
require("core-js/modules/es.object.entries");
require("core-js/modules/es.regexp.constructor");
require("core-js/modules/es.regexp.exec");
require("core-js/modules/es.regexp.to-string");
require("core-js/modules/es.string.replace");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.replaceText = exports.replaceTemplate = exports.replaceRoute = exports.replaceProductRoute = void 0;
var _get = _interopRequireDefault(require("lodash/get"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _isNil = _interopRequireDefault(require("lodash/isNil"));
var replaceText = function replaceText(str, replacements) {
  if ((0, _isEmpty.default)(replacements) || !str) {
    return str;
  }
  return Object.entries(replacements).reduce(function (out, _ref) {
    var key = _ref[0],
      replacement = _ref[1];
    return out.replace("{" + key + "}", replacement);
  }, str);
};
exports.replaceText = replaceText;
var replaceTemplate = function replaceTemplate(template, properties, product, defaultValue) {
  if (defaultValue === void 0) {
    defaultValue = '';
  }
  if (!template) {
    return defaultValue;
  }
  if (typeof properties === 'string') {
    var value = (0, _get.default)(product, properties);
    if ((0, _isNil.default)(value)) {
      return defaultValue;
    }
    return template.replace(new RegExp("%" + properties + "%", 'g'), Array.isArray(value) ? value.join(', ') : String(value));
  }
  return properties ? properties.reduce(function (out, property) {
    var value = (0, _get.default)(product, property);
    return out.replace(new RegExp("%" + property + "%", 'g'), Array.isArray(value) ? value.join(', ') : String(value) || defaultValue);
  }, template) : template;
};
exports.replaceTemplate = replaceTemplate;
var replaceRoute = function replaceRoute(productName) {
  return productName.replace('-', '/');
};
exports.replaceRoute = replaceRoute;
var replaceProductRoute = function replaceProductRoute(product, productTemplates) {
  if (!product.hasOwnPage || !productTemplates) {
    console.error('Не удалось сформировать url продукта', {
      productId: product.id,
      hasOwnPage: product.hasOwnPage,
      productTemplates
    });
    return '';
  }
  var organizationAlias = product.organization.alias,
    alias = product.alias;
  return productTemplates.replace(':paramBankAlias', organizationAlias).replace(':paramProductAlias', alias);
};
exports.replaceProductRoute = replaceProductRoute;